import script from "./TheInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./TheInfo.vue?vue&type=script&setup=true&lang=js"

import "./TheInfo.vue?vue&type=style&index=0&id=27875d6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27875d6e"]])

export default __exports__